var map = {
	"./components/boxes-creator.vue": "WS71",
	"./components/boxes.vue": "k/Em",
	"./components/bread-difference.vue": "Zfpd",
	"./components/bread-differences.vue": "TM1A",
	"./components/file-remove.vue": "Qqyc",
	"./components/loader.vue": "EDPp",
	"./components/login-view.vue": "oYfa",
	"./components/recipe-calculator.vue": "55u5",
	"./components/unit-price.vue": "lt9n",
	"./components/wrapper.vue": "PseZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+fAT";